import type { CSSProperties } from "react";
import type { ArtManifest, Language } from "../story/types";

interface Props {
  artId: string;
  manifest: ArtManifest;
  language: Language;
}

export function ArtPanel({ artId, manifest, language }: Props) {
  const asset = manifest.assets[artId];
  if (!asset) return <div className="art-panel art-panel--missing" data-missing-art={artId} />;

  if (asset.crop) {
    const { crop } = asset;
    const resolvedSrc = new URL(asset.src, document.baseURI).href;
    const style = {
      "--art-src": `url("${resolvedSrc}")`,
      "--sheet-width": `${(asset.sheet.width / crop.width) * 100}%`,
      "--sheet-height": `${(asset.sheet.height / crop.height) * 100}%`,
      "--crop-x": `${(crop.x / (asset.sheet.width - crop.width || 1)) * 100}%`,
      "--crop-y": `${(crop.y / (asset.sheet.height - crop.height || 1)) * 100}%`,
    } as CSSProperties;
    return <div className="art-panel art-panel--crop" role="img" aria-label={asset.alt?.[language] ?? ""} style={style} />;
  }

  return null;
}
